const button=document.getElementById("wa-button");
const chat=document.getElementById("wa-chat");
const close=document.getElementById("wa-close");

button.onclick=()=>{
chat.style.display="block";
};

close.onclick=()=>{
chat.style.display="none";
};

document.getElementById("wa-send").onclick=function(){

let message=document.getElementById("wa-text").value;

if(message==""){
message="I Want To Place An Order?";
}

window.open(
"https://wa.me/923291655405?text="+encodeURIComponent(message),
"_blank"
);

};